// Accordéon « Le produit en détail » (sections/product-detail.liquid).
// Une seule rubrique ouverte à la fois ; cliquer sur la rubrique ouverte la
// referme. Les déclencheurs sont de vrais <button> (souris, toucher,
// Entrée/Espace au clavier) ; aria-expanded et l'attribut inert des
// panneaux fermés tiennent les lecteurs d'écran et la tabulation à jour.
// Écoute déléguée limitée à [data-oc-pd-accordion] : fonctionne aussi après
// un rechargement de la section dans l'éditeur de thème.
(function () {
  if (window.__ocPdAccordionInit) return;
  window.__ocPdAccordionInit = true;

  function setOpen(item, open) {
    var trigger = item.querySelector('.oc-pd-trigger');
    var panel = item.querySelector('.oc-pd-panel');
    item.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', String(open));
    if (panel) panel.inert = !open;
  }

  function toggle(item) {
    var root = item.closest('[data-oc-pd-accordion]');
    var willOpen = !item.classList.contains('is-open');
    if (root) {
      root.querySelectorAll('.oc-pd-item.is-open').forEach(function (other) {
        if (other !== item) setOpen(other, false);
      });
    }
    setOpen(item, willOpen);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-oc-pd-accordion] .oc-pd-trigger');
    if (!trigger) return;
    toggle(trigger.closest('.oc-pd-item'));
  });

  // Éditeur de thème : ouvrir la rubrique sélectionnée dans le panneau.
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest('.oc-pd-item');
    if (item && !item.classList.contains('is-open')) toggle(item);
  });
})();
